import { __assign, __extends, __spreadArray } from "tslib";
import React from 'react';
import { GALLERY_v4_CONSTS } from '@wix/photography-client-lib';
import { mergeNestedObjects } from 'pro-gallery-lib';
import { InfoElement, EXTERNAL_INFO_TYPE, INFO_EVENTS, } from '@wix/pro-gallery-info-element';
import '../styles/infoElement.global.scss';
import { debounce } from 'lodash';
import prependHttpExtra from 'prepend-http-extra';
import { utils } from '../utils'; // check with guy if needed!
import { experimentsWrapper, ItemActions, logger, Wix, TPADimensionsHelper, styleParamsHelper, itemLoaded, itemLoadStart, navigationHelper, } from '@wix/photography-client-lib';
import GalleryEmpty from './galleryEmpty';
import { getItemsFromDb, getGalleryDataFromDB } from '../helpers/itemsHelper'; // use only here and in galleryContainerNew.
import fullscreenHelper from '../helpers/fullscreenHelper'; // only use here!
import * as fedopsLogger from '@wix/fedops-logger';
import { ProGalleryWrapper } from './proGalleryWrapper';
import { CustomImageRenderer, getCustomArrowsRenderer, } from '@wix/photography-shared-ui';
var ProGalleryTPAWrapper = /** @class */ (function (_super) {
    __extends(ProGalleryTPAWrapper, _super);
    function ProGalleryTPAWrapper(props) {
        var _this = _super.call(this, props) || this;
        _this.handleStyleChange = function () {
            if (utils.isDev()) {
                console.count('galleryContainer handleStyleChange');
            }
            // TD: - this is probably not used anymore - check if the fullscreen is listening to this event
            // Wix.Styles.getStyleParams(style => {
            //   window.postMessage({
            //     type: Wix.Events.STYLE_PARAMS_CHANGE,
            //     payload: style
            //   }, utils.getUrlPrefix());
            var styles = styleParamsHelper.getStylesFromWix();
            utils.isVerbose() &&
                console.log('Parsed styles from Wix', {
                    fromWix: styles,
                    inState: _this.state.styles,
                });
            _this.setState({
                styles: mergeNestedObjects(styles, _this.props.styles),
            });
        };
        _this.handleNewGalleryStructure = function (newGalleryStructureData) {
            var numOfItems = newGalleryStructureData.numOfItems, container = newGalleryStructureData.container, options = newGalleryStructureData.options, layoutHeight = newGalleryStructureData.layoutHeight, isInfinite = newGalleryStructureData.isInfinite, isFixedHorizontlaGalleryRatio = newGalleryStructureData.isFixedHorizontlaGalleryRatio, updatedHeight = newGalleryStructureData.updatedHeight;
            _this.galleryStyles = options;
            var galleryHeight = TPADimensionsHelper.setWixHeight({
                height: layoutHeight,
                offsetTop: _this.props.offsetTop,
                styleParams: options,
                container: container,
                numOfItems: numOfItems,
                isInfinite: isInfinite,
                isFixedHorizontlaGalleryRatio: isFixedHorizontlaGalleryRatio,
                updatedHeight: updatedHeight,
                setHeightImp: Wix.setHeight,
                clearHeight: Wix.clearHeight,
            });
            var prevGalleryHeight = _this.galleryHeight;
            var containerGalleryHeight = container.galleryHeight;
            _this.galleryHeight =
                galleryHeight || prevGalleryHeight || containerGalleryHeight;
            // if (utils.isInAlbumsBuilder()) {
            //   try {
            //     fullscreenHelper.updateWorkerStyles({
            //       ...this.state.styles,
            //       ...this.props.styles,
            //     });
            //   } catch (e) {
            //     console.error('Cannot assign trigger action on window')
            //   }
            // }
        };
        _this.handleCloseFullscreen = function () {
            if (utils.isDev()) {
                console.log('Fullscreen closed callback');
            }
            _this.compId = Wix.Utils.getCompId();
            var fullscreenData = (utils.getWorkerWindow()['pro-gallery-data-' + _this.compId] || {}).fullscreenData;
            if (!fullscreenData) {
                console.warn('Closed fullscreen without data');
                return;
            }
            _this.shouldSendCurrentIdx = true;
            _this.setState({ activeIndex: fullscreenData.currentGalleryItemIdx });
            if (_this.galleryStyles.scrollDirection ===
                GALLERY_v4_CONSTS.scrollDirection.HORIZONTAL) {
                var fixBannerHeight = 75;
                var pos = _this.state.container.scrollBase - fixBannerHeight;
                Wix.scrollTo(0, pos);
            }
        };
        _this.handleEvent = function (eventName, eventData) {
            switch (eventName) {
                case GALLERY_v4_CONSTS.events.ITEM_CREATED:
                    _this.onItemCreated();
                    break;
                case GALLERY_v4_CONSTS.events.ITEM_LOADED:
                    _this.onItemLoaded();
                    break;
                case GALLERY_v4_CONSTS.events.ITEM_ACTION_TRIGGERED:
                    _this.onItemActionTriggered(eventData);
                    break;
                case GALLERY_v4_CONSTS.events.GALLERY_CHANGE:
                    _this.handleNewGalleryStructure(eventData);
                    break;
                case GALLERY_v4_CONSTS.events.NEED_MORE_ITEMS:
                    _this.getMoreItems(eventData);
                    break;
                case INFO_EVENTS.SHARE_BUTTON_CLICKED:
                    _this.handleItemActions('share', eventData);
                    break;
                case INFO_EVENTS.TEXT_DOWNLOAD_BUTTON_CLICKED:
                    _this.handleItemActions('downloadTextItem', eventData);
                    _this.reportBiEvent('downloadTextItem', eventData);
                    break;
                case INFO_EVENTS.LOVE_BUTTON_CLICKED:
                    _this.updateLocalLoveData(eventData.id);
                    _this.handleItemActions('toggleLove', eventData);
                    _this.handleItemActions('postLoveActivity', eventData);
                    break;
                case INFO_EVENTS.DOWNLOAD_BUTTON_CLICKED:
                    _this.reportBiEvent('onDownloadButtonClicked', eventData);
                    break;
                case INFO_EVENTS.CUSTOM_BUTTON_CLICKED:
                    _this.reportBiEvent('onBuyNowClicked', eventData);
                    break;
                default:
                    if (utils.isVerbose()) {
                        console.log(eventName, 'is not handled in handleEvent function');
                    }
            }
        };
        _this.processPgItemPropsForInfoElement = function (pgItemProps, infoType) {
            var wrapperProps = {
                viewMode: _this.getViewMode(),
                eventsListener: _this.handleEvent,
                infoType: infoType,
                shouldUseNewSocialSharePopup: _this.shouldUseNewSocialSharePopup,
            };
            var itemLoveData = __assign({}, _this.state.itemsLoveData[pgItemProps.id]);
            return __assign(__assign(__assign({}, pgItemProps), wrapperProps), itemLoveData);
        };
        _this.hoverInfoElement = function (pgItemProps) { return (React.createElement(InfoElement, __assign({}, _this.processPgItemPropsForInfoElement(pgItemProps, EXTERNAL_INFO_TYPE.HOVER)))); };
        _this.externalInfoElement = function (pgItemProps, placement) { return (React.createElement(InfoElement, __assign({}, _this.processPgItemPropsForInfoElement(pgItemProps, EXTERNAL_INFO_TYPE.EXTERNAL)))); };
        _this.slideshowInfoElement = function (pgItemProps) { return (React.createElement(InfoElement, __assign({}, _this.processPgItemPropsForInfoElement(pgItemProps, EXTERNAL_INFO_TYPE.SLIDESHOW)))); };
        if (_this.useNewAPIs() && props.galleryDataSrc === 'prerenderedGallery') {
            _this.items = [];
            _this.getInitialGalleryData('constructor');
        }
        else {
            _this.items = props.items;
        }
        _this.state = {
            items: _this.items.map(function (item) { return item.id || item.itemId; }),
            totalItemsCount: _this.useNewAPIs() && props.galleryDataSrc === 'prerenderedGallery'
                ? 0 // 0 until galleryData will arrive from the server
                : props.totalItemsCount,
            isInDisplay: true,
            activeIndex: 0,
            styles: __assign({}, props.styles),
            container: {},
            scroll: {
                y: 0,
                scrollTop: 0,
                scale: 1,
            },
            itemsLoveData: {},
            isAccessible: false,
        };
        _this.id = (Date.now() % 10000).toString();
        _this.createContainer = _this.createContainer.bind(_this);
        _this.handleResizeEvent = _this.handleResizeEvent.bind(_this);
        _this.handleEditModeChange = _this.handleEditModeChange.bind(_this);
        _this.galleryPublished = _this.galleryPublished.bind(_this);
        _this.handleStyleChange = _this.handleStyleChange.bind(_this);
        _this.handleCloseFullscreen = _this.handleCloseFullscreen.bind(_this);
        _this.handleDisplayChange = _this.handleDisplayChange.bind(_this);
        _this.debouncedResizeEvent = debounce(_this.handleResizeEvent, 500);
        _this.handleEvent = _this.handleEvent.bind(_this);
        _this.onLoveCountsFetched = _this.onLoveCountsFetched.bind(_this);
        _this.setAccessibilityIfNeeded = _this.setAccessibilityIfNeeded.bind(_this);
        _this.getInitialGalleryData = _this.getInitialGalleryData.bind(_this);
        _this.shouldUseNewSocialSharePopup = true;
        fullscreenHelper.init(props);
        if (_this.items.length === 0) {
            _this.reportAppLoaded();
        }
        _this.isDevAccessibility = utils.shouldDebug('accessibility');
        _this.itemActions = new ItemActions();
        return _this;
    }
    ProGalleryTPAWrapper.prototype.handleDisplayChange = function (isInDisplay) {
        this.setState({ isInDisplay: isInDisplay });
        switch (isInDisplay) {
            case true:
                this.initEventListeners();
                break;
            case false:
                this.removeEventListeners();
                break;
            default:
                break;
        }
    };
    ProGalleryTPAWrapper.prototype.onItemLoaded = function () {
        itemLoaded();
    };
    ProGalleryTPAWrapper.prototype.onItemCreated = function () {
        if (!window.appLoaded) {
            this.reportAppLoaded();
        }
        itemLoadStart();
    };
    ProGalleryTPAWrapper.prototype.useNewAPIs = function () {
        try {
            return !window.isArtStore;
        }
        catch (e) { }
        return false;
    };
    ProGalleryTPAWrapper.prototype.reportAppLoaded = function () {
        if (utils.isTest()) {
            return;
        }
        if (!window.appLoaded) {
            // not supposed to be called if window.appLoaded is true, but just in case.
            window.appLoaded = true;
            if (window.fedopsAppName) {
                try {
                    console.log(window.fedopsAppName, 'Loaded');
                    // window.fedopsAppName='pro-gallery-statics' || 'art-store-statics'
                    var _fedopsLogger = fedopsLogger.create(window.fedopsAppName);
                    if (_fedopsLogger) {
                        _fedopsLogger.appLoaded();
                    }
                }
                catch (e) {
                    // console.log('fedopsLogger: apploaded failed ', appName, e);
                }
            }
        }
    };
    ProGalleryTPAWrapper.prototype.onItemActionTriggered = function (itemProps) {
        var styles = this.state.styles;
        var itemClick = styles.itemClick;
        if (!styles.fullscreen || itemClick === 'nothing') {
            return;
        }
        if (itemProps && itemProps.idx >= 0) {
            if (itemClick === 'link' && itemProps.linkType) {
                switch (itemProps.linkType) {
                    case 'none':
                        break;
                    case 'web':
                        var linkOpenType = 
                        // in preview never open link in current window (causes many errors)
                        utils.isEditor() || utils.isPreview()
                            ? '_blank'
                            : itemProps.linkOpenType;
                        window.open(prependHttpExtra(itemProps.linkUrl), linkOpenType);
                        break;
                    case 'wix':
                        Wix.navigateTo(itemProps.linkData);
                        break;
                    default:
                        Wix.navigateToPage(itemProps.linkUrl, { noTransition: true });
                }
            }
            else if (itemClick === 'expand' || itemClick === 'fullscreen') {
                var item = this.items.find(function (_item) { return _item.itemId === itemProps.id; });
                fullscreenHelper.toggleFullscreen(item, {
                    styles: mergeNestedObjects(this.state.styles, this.props.styles),
                    isAccessible: this.state.isAccessible,
                    totalItemsCount: this.props.totalItemsCount,
                });
            }
        }
    };
    ProGalleryTPAWrapper.prototype.checkIfAccessible = function () {
        if (!utils.isSite()) {
            return;
        }
        if (Wix && typeof Wix.isVisualFocusEnabled === 'function') {
            try {
                Wix.isVisualFocusEnabled(this.setAccessibilityIfNeeded);
            }
            catch (e) {
                //
            }
        }
    };
    ProGalleryTPAWrapper.prototype.setAccessibilityIfNeeded = function (isVisualFocusEnabled) {
        // suppose to be 'const isAccessible = isVisualFocusEnabled || this.isDevAccessibility' but isVisualFocusEnabled was always 'undefined' in iFrame with the old client lib util 'isAccessibilityEnabled'
        // so was not working correctly for iFrame (a bug). We will leave it this way to not change sites.
        var isAccessible = this.isDevAccessibility;
        if (isAccessible !== this.state.isAccessible) {
            this.setState({
                isAccessible: isAccessible,
            });
        }
    };
    ProGalleryTPAWrapper.prototype.initEventListeners = function () {
        if (!this.eventListenersSet) {
            this.eventListenersSet = true;
            navigationHelper.subscribeToOnDisplayChange(this.handleDisplayChange);
            this.windowEventsFunctions.forEach(function (x) { return window.addEventListener.apply(window, x); });
            this.wixEventsFunctions.forEach(function (x) { return Wix.addEventListener && Wix.addEventListener.apply(Wix, x); });
        }
    };
    ProGalleryTPAWrapper.prototype.initEventsFunction = function () {
        this.windowEventsFunctions = [];
        this.wixEventsFunctions = [];
        this.wixEventsFunctions.push([
            Wix.Events.SITE_PUBLISHED,
            this.galleryPublished,
        ]);
        this.wixEventsFunctions.push([
            Wix.Events.STYLE_PARAMS_CHANGE,
            this.handleStyleChange,
        ]);
        this.wixEventsFunctions.push([
            Wix.Events.SETTINGS_UPDATED,
            this.handleStyleChange,
        ]);
        this.wixEventsFunctions.push([
            Wix.Events.DEVICE_TYPE_CHANGED,
            this.handleResizeEvent,
        ]);
        this.wixEventsFunctions.push([
            Wix.Events.EDIT_MODE_CHANGE,
            this.handleEditModeChange,
        ]);
        // global events
        this.windowEventsFunctions.push(['resize', this.debouncedResizeEvent]);
        this.windowEventsFunctions.push([
            'orientationchange',
            this.debouncedResizeEvent,
        ]);
    };
    // TODO Ask guy how the fullscreen callback works now. (remember the scroll to top bug)
    ProGalleryTPAWrapper.prototype.initPersistentEventListeners = function () {
        window.addEventListener('fullscreen_closed', this.handleCloseFullscreen); // TD: this shouldnt be an event //TODO is there a new fullscreen implementation?
    };
    ProGalleryTPAWrapper.prototype.removeEventListeners = function () {
        if (this.eventListenersSet) {
            this.eventListenersSet = false;
            navigationHelper.unsubscribeToOnDisplayChange(this.handleDisplayChange);
            this.windowEventsFunctions.forEach(function (x) {
                return window.removeEventListener.apply(window, x);
            });
            this.wixEventsFunctions.forEach(function (x) { return Wix.removeEventListener && Wix.removeEventListener.apply(Wix, x); });
        }
    };
    ProGalleryTPAWrapper.prototype.getCurrentIdxForGallery = function () {
        var activeIndex = false;
        if (this.shouldSendCurrentIdx) {
            this.shouldSendCurrentIdx = false;
            activeIndex = this.state.activeIndex;
        }
        return activeIndex;
    };
    ProGalleryTPAWrapper.prototype.getScrollingElement = function () {
        return {
            addEventListener: function (eventName, callback) {
                // console.count('PROGALLERY [visibilities] - Wix.addEventListener: ' + this.id);
                eventName = eventName.toUpperCase();
                Wix.addEventListener(eventName, callback);
            },
            removeEventListener: function (eventName, callback) {
                // console.count('PROGALLERY [visibilities] - Wix.removeEventListener: ' + this.id);
                Wix.removeEventListener(eventName.toUpperCase(), callback);
            },
            scrollTo: function (x, y, options) {
                if (!utils.isEditor()) {
                    Wix.scrollTo(x, y, options);
                }
            },
        };
    };
    ProGalleryTPAWrapper.prototype.galleryPublished = function () {
        logger.log('galleryPublished', {
            numberOfItems: this.props.totalItemsCount,
            styleParams: JSON.stringify(this.state.styles),
        });
    };
    ProGalleryTPAWrapper.prototype.handleResizeEvent = function () {
        this.createContainer();
    };
    ProGalleryTPAWrapper.prototype.handleEditModeChange = function () {
        utils.updateViewMode();
        this.handleResizeEvent();
    };
    ProGalleryTPAWrapper.prototype.createContainer = function () {
        var _this = this;
        Wix.getBoundingRectAndOffsets(function (rect) {
            _this.setState({
                container: {
                    scrollBase: _this.props.offsetTop + rect.offsets.y * rect.scale || 0,
                    width: TPADimensionsHelper.protectGalleryWidth(utils.isMobile() ? document.body.clientWidth : window.innerWidth),
                    height: TPADimensionsHelper.protectGalleryHeight(window.innerHeight, _this.props.offsetTop),
                },
            });
        });
    };
    ProGalleryTPAWrapper.prototype.onLoveCountsFetched = function (photoId2Love) {
        var _this = this;
        var itemsLoveData = {};
        Object.entries(photoId2Love).forEach(function (_a) {
            var id = _a[0], loveCount = _a[1];
            itemsLoveData[id] = {
                loveCount: loveCount,
                isLoved: _this.itemActions.isLoved(id),
            };
        });
        this.setState({ itemsLoveData: itemsLoveData });
    };
    ProGalleryTPAWrapper.prototype.updateLocalLoveData = function (id) {
        var _a;
        var itemsLoveData = this.state.itemsLoveData;
        var updatedItemLoveData;
        if (itemsLoveData[id]) {
            updatedItemLoveData = {
                isLoved: !itemsLoveData[id].isLoved,
                loveCount: itemsLoveData[id].isLoved
                    ? itemsLoveData[id].loveCount - 1
                    : itemsLoveData[id].loveCount + 1,
            };
        }
        else {
            updatedItemLoveData = {
                isLoved: true,
                loveCount: 1,
            };
        }
        var updatedItemsLoveData = Object.assign({}, itemsLoveData, (_a = {},
            _a[id] = updatedItemLoveData,
            _a));
        this.setState({ itemsLoveData: updatedItemsLoveData });
    };
    ProGalleryTPAWrapper.prototype.initItemActions = function () {
        var _this = this;
        this.compId = Wix.Utils.getCompId();
        this.galleryId = window.galleryId; // TD: move to props
        Wix.getCurrentPageId(function (pageId) {
            _this.pageId = pageId;
            Wix.Styles.getStyleId(function (styleId) {
                _this.styleId = styleId;
                Wix.Utils.getSectionUrl({
                    sectionId: utils.getFullscreenSectionId(),
                }, function (section) {
                    _this.fullscreenUrl = section.url;
                    _this.itemActions.initWidgetData({
                        compId: _this.compId,
                        pageId: _this.pageId,
                        styleId: _this.styleId,
                        galleryId: _this.galleryId,
                        fullscreenUrl: _this.fullscreenUrl,
                        onLoveCountsFetched: _this.onLoveCountsFetched,
                        viewMode: _this.getViewMode(),
                    });
                });
            });
        });
    };
    ProGalleryTPAWrapper.prototype.componentDidMount = function () {
        this.initEventsFunction();
        this.initEventListeners();
        this.initPersistentEventListeners();
        this.createContainer();
        this.initItemActions();
        this.checkIfAccessible();
    };
    ProGalleryTPAWrapper.prototype.componentWillUnmount = function () {
        this.removeEventListeners();
    };
    ProGalleryTPAWrapper.prototype.canRender = function () {
        if (this.state.styles.gotStyleParams !== true ||
            isNaN(this.state.container.scrollBase)) {
            return null;
        }
        if (this.state.container.width === 0) {
            if (utils.isVerbose()) {
                console.log("Can't create gallery without container width - document wasn't loaded");
            }
            return null;
        }
        if (utils.isVerbose()) {
            console.log('PROGALLERY [CAN_RENDER] wixWrapper', this.id, true, this.state.styles.gotStyleParams, this.state.container.scrollBase);
        }
        return true;
    };
    ProGalleryTPAWrapper.prototype.getInitialGalleryData = function (calledFrom) {
        var _this = this;
        getGalleryDataFromDB(0, calledFrom).then(function (data) {
            // sometimes the galleryDataSrc was changed until we got here. (getInitialGalleryData)
            // getInitialGalleryData was called from the constructor, but maybe the galleryTPAWrapper was updated with items from wixCode (componentWillReceiveProps)
            if (_this.props.galleryDataSrc !== 'manuallySetImages') {
                if (data && data.pageResponse) {
                    _this.items = data.pageResponse.items;
                    var totalItemsCount = data.pageResponse.totalItemsCount;
                    _this.setState({
                        items: _this.items.map(function (item) { return item.id || item.itemId; }),
                        totalItemsCount: totalItemsCount,
                    });
                }
            }
        });
    };
    ProGalleryTPAWrapper.prototype.getMoreItems = function (from) {
        var _this = this;
        if (this.props.galleryDataSrc !== 'manuallySetImages') {
            // do not fetch items from db if the src is wixCode
            getItemsFromDb(from).then(function (items) {
                var curItems = _this.items;
                _this.items = curItems.slice(0, from).concat(items); // do not double append items
                _this.setState({
                    items: _this.items.map(function (item) { return item.id || item.itemId; }),
                });
            });
        }
    };
    ProGalleryTPAWrapper.prototype.componentWillReceiveProps = function (nextProps) {
        if (nextProps.galleryDataSrc === 'manuallySetImages') {
            // if items from wixCode
            this.items = nextProps.items;
            this.setState({
                items: this.items.map(function (item) { return item.id || item.itemId; }),
                totalItemsCount: nextProps.totalItemsCount,
            });
        }
        else if (this.props.galleryDataSrc === 'manuallySetImages' &&
            nextProps.galleryDataSrc === 'prerenderedGallery') {
            // if items were from wixCode and now are not (Wix.Events.COMPONENT_DISCONNECT)
            // we will need to get items from the server and set those as the items.
            this.getInitialGalleryData('componentWillReceiveProps');
        }
        if (nextProps.offsetTop !== this.props.offsetTop) {
            Wix.setHeight(this.galleryHeight - this.props.offsetTop + nextProps.offsetTop);
        }
    };
    ProGalleryTPAWrapper.prototype.handleItemActions = function (action, actionData) {
        var item;
        switch (action) {
            case 'share':
                this.itemActions.share(actionData.network, actionData.shareProps, 'gallery');
                break;
            case 'showTooltip':
                this.itemActions.showTooltip(actionData.event, actionData.key);
                break;
            case 'hideTooltip':
                this.itemActions.hideTooltip();
                break;
            case 'downloadTextItem':
                item = {
                    html: actionData.html,
                    style: actionData.style,
                };
                this.itemActions.downloadTextItem(item, 'gallery');
                break;
            case 'postLoveActivity':
                item = {
                    type: actionData.type,
                    itemId: actionData.itemId,
                    id: actionData.id,
                    idx: actionData.idx,
                    hashtag: actionData.hashtag,
                };
                this.itemActions.postLoveActivity(item);
                break;
            case 'toggleLove':
                this.itemActions.toggleLove(actionData.id, actionData.layout);
                break;
        }
    };
    ProGalleryTPAWrapper.prototype.reportBiEvent = function (eventName, eventData) {
        switch (eventName) {
            case 'onDownloadButtonClicked':
            case 'downloadTextItem':
                logger.log('download', {
                    origin: 'gallery',
                    gallery_id: this.props.galleryId,
                });
                break;
            case 'onBuyNowClicked':
                logger.log('buyBuyNowClick');
                break;
        }
    };
    ProGalleryTPAWrapper.prototype.getViewMode = function () {
        var viewMode = '';
        if (window &&
            window.Wix &&
            window.Wix.Utils &&
            window.Wix.Utils.getViewMode) {
            viewMode = window.Wix.Utils.getViewMode();
        }
        switch (viewMode.toLowerCase()) {
            case 'editor':
                return GALLERY_v4_CONSTS.viewMode.EDIT;
            case 'preview':
                return GALLERY_v4_CONSTS.viewMode.PREVIEW;
            case 'site':
            default:
                return GALLERY_v4_CONSTS.viewMode.SITE;
        }
    };
    ProGalleryTPAWrapper.prototype.customImageRenderer = function (props) {
        return React.createElement(CustomImageRenderer, __assign({}, props));
    };
    ProGalleryTPAWrapper.prototype.getCustomComponents = function () {
        return {
            customHoverRenderer: this.hoverInfoElement,
            customInfoRenderer: this.externalInfoElement,
            customImageRenderer: this.customImageRenderer,
            customNavArrowsRenderer: getCustomArrowsRenderer(this.state.styles),
        };
    };
    ProGalleryTPAWrapper.prototype.render = function () {
        var viewMode = this.getViewMode();
        var options = mergeNestedObjects(this.state.styles, this.props.styles);
        var emptyGalleryInEditor = viewMode === GALLERY_v4_CONSTS.viewMode.EDIT &&
            (this.items.length === 0 ||
                (this.items.length === 1 && Object.keys(this.items[0]).length === 0)); // sometimes the items list contain one empty item
        var key;
        try {
            key = __spreadArray(__spreadArray(__spreadArray([], this.items, true), Object.values(options || {}), true), Object.values(this.state.container || {}), true).map(function (item) { return String(item.itemId || item)[0] || ''; })
                .join('');
        }
        catch (e) {
            key = Math.random();
        }
        return (this.canRender() &&
            (emptyGalleryInEditor ? (React.createElement(GalleryEmpty, null)) : (React.createElement(ProGalleryWrapper, __assign({}, this.props, { totalItemsCount: this.state.totalItemsCount, container: this.state.container, key: key, id: this.id, items: this.items, options: options, settings: { isAccessible: this.state.isAccessible }, eventsListener: this.handleEvent, activeIndex: this.getCurrentIdxForGallery(), isInDisplay: this.state.isInDisplay, viewMode: viewMode, customComponents: this.getCustomComponents(), isPrerenderMode: false })))));
    };
    return ProGalleryTPAWrapper;
}(React.Component));
export default ProGalleryTPAWrapper;
//# sourceMappingURL=galleryTPAWrapper.js.map